<template>
  <section>
    <section class="footer-head">
      <section class="footer-head-box">
        <div class="homes-width">
          闽ICP备2022000874号-1
        </div>
        <div class="homes-width">
          <img src="./../../../assets/guohui.png" style="width: 20px; height: 20px;vertical-align: sub;" alt="">
        </div>
        <div class="homes-width">
          闽公网安备 35080202351021号
        </div>
      </section>
    </section>
  </section>
</template>
<script>
export default {
  data () {
    return {


    }
  },
  created () {

  },
  mounted () {

  },
  methods: {

  }
}
</script>
<style lang="less" scoped>
.footer-head {
  width: 100%;
  height: 60px;
  // background: #151b26;
  margin-top: 24px;
  // background-image: url('./../../../assets/footer-bg.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  // position: fixed;
  // bottom: 0px;
  .footer-head-box {
    width: 100%;
    height: 60px;
    text-align: center;

    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 400;
    font-size: 14px;
    color: #bfbfbf;
    line-height: 60px;
    font-style: normal;
  }
  .homes-width {
    display: inline-block;
    margin-right: 15px;
  }
  .homes-width:last-child {
    margin-right: 0;
  }
}
</style>
